import script from "./TariffMainOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./TariffMainOption.vue?vue&type=script&setup=true&lang=ts"

import "./TariffMainOption.vue?vue&type=style&index=0&id=d242b4b6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d242b4b6"]])

export default __exports__